import { render, staticRenderFns } from "./DocumentView.vue?vue&type=template&id=684c8f9a&scoped=true"
import script from "./DocumentView.vue?vue&type=script&lang=js"
export * from "./DocumentView.vue?vue&type=script&lang=js"
import style0 from "./DocumentView.vue?vue&type=style&index=0&id=684c8f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684c8f9a",
  null
  
)

export default component.exports